import type { SidePanelTabId, SidePanelUiMetadata } from './sidePanelUi.model';

export function changeTabInSidePanel(tabId: string, activeTab: SidePanelTabId) {
  return {
    type: 'SIDE_PANEL_ACTIVE_TAB_CHANGED' as const,
    activeTab,
    tabId,
  };
}
export type SidePanelActiveTabChanged = ReturnType<typeof changeTabInSidePanel>;

export function updateSidePanelMetadata(tabId: string, metadata: SidePanelUiMetadata) {
  return {
    type: 'UPDATE_SIDE_PANEL_METADATA' as const,
    tabId,
    metadata,
  };
}
export type UpdateSidePanelMetadata = ReturnType<typeof updateSidePanelMetadata>;
export type SidePanelUiAction = SidePanelActiveTabChanged | UpdateSidePanelMetadata;
